export const copy = (text: string): Promise<void> => {
  return navigator.clipboard.writeText(text);
};

export const copyAsync = async (textPromise: Promise<string>) => {
  const text = (await textPromise) ? (await textPromise).toString() : '';
  const response = await copyToClipboard(text);

  if (response !== null && response !== undefined) {
    return response;
  } else {
    const blob = new Blob([text], { type: 'text/plain' });
    return navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': blob,
      }),
    ]);
  }
};

export const copyText = async (text: string | Promise<string>) => {
  const resolvedText = Promise.resolve(text);

  if (navigator.clipboard && window.isSecureContext) {
    return copy(await resolvedText);
  } else {
    return await copyAsync(resolvedText);
  }
};

async function copyToClipboard(textToCopy: string): Promise<void> {
  const textarea = document.createElement('textarea');

  textarea.value = textToCopy;
  textarea.style.position = 'absolute';
  textarea.style.left = '-99999999px';
  document.body.prepend(textarea);
  textarea.select();

  try {
    Promise.resolve();
  } catch (err) {
    Promise.reject(err);
  } finally {
    textarea.remove();
  }
}
